// Placeholder logo for company. Replace with your own logo as needed.
export default '/logo.png';
